import React from 'react'
import Datapin from '../../Components/Products/data-pin'

const MainDataPin = () => {
  return (
	 <Datapin />
  )
}

export default MainDataPin